import { render, staticRenderFns } from "./ShareInputCard.vue?vue&type=template&id=cd06c458&scoped=true&"
import script from "./ShareInputCard.vue?vue&type=script&lang=js&"
export * from "./ShareInputCard.vue?vue&type=script&lang=js&"
import style0 from "./ShareInputCard.vue?vue&type=style&index=0&id=cd06c458&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd06c458",
  null
  
)

export default component.exports